import { ArrowLeft } from 'lucide-react';

const BookingsHistorySkeleton = () => {
  return (
    <div className="min-h-screen gradient-mesh pb-24 md:pb-28">
      <div className="sticky top-0 z-50 glass-strong border-b" style={{ paddingTop: 'env(safe-area-inset-top)' }}>
        <div className="max-w-3xl mx-auto flex items-center gap-3 h-14 md:h-16 px-4 md:px-6">
          <div className="p-1.5"><ArrowLeft className="h-5 w-5 opacity-20" /></div>
          <div className="h-6 w-32 rounded-lg bg-secondary/40 shimmer-wrapper opacity-50" />
        </div>
      </div>

      <main className="max-w-3xl mx-auto px-4 md:px-6 pt-4 md:pt-6 space-y-3 md:space-y-4">
        <div className="space-y-4 pt-2">
          {[1, 2, 3].map((i) => (
            <div key={i} className="rounded-2xl bg-card p-4 md:p-5 shadow-card border border-border/50 min-h-[225px] flex flex-col justify-between">
              <div>
                <div className="flex items-center justify-between mb-4">
                  <div className="h-5 w-32 rounded-lg bg-secondary/50 shimmer-wrapper opacity-40" />
                  <div className="h-5 w-16 rounded-full bg-secondary/40 shimmer-wrapper opacity-30" />
                </div>
                
                <div className="h-4 w-48 rounded-md bg-secondary/40 shimmer-wrapper opacity-30 mb-6" />
              </div>

              {/* High-Fidelity Status Tracker Mockup */}
              <div className="px-1 relative h-16 flex items-center mt-auto border-t border-border/30 pt-4">
                <div className="absolute top-1/2 left-0 w-full h-0.5 bg-muted/20 -translate-y-1/2" />
                <div className="relative w-full flex justify-between">
                  {[1, 2, 3, 4, 5].map((dot) => (
                    <div key={dot} className="flex flex-col items-center gap-1.5 z-10">
                      <div className="h-6 w-6 rounded-full bg-secondary/50 shimmer-wrapper ring-4 ring-card opacity-30" />
                      <div className="h-1.5 w-8 rounded-full bg-secondary/40 shimmer-wrapper opacity-20" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
          <div className="h-6" /> {/* Spacer */}
        </div>
      </main>
    </div>
  );
};

export default BookingsHistorySkeleton;
